var Component = require("!../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./integrationsPremiumFeatureModal.vue"),
  /* template */
  require("!!../../../../node_modules/vue-loader/lib/template-compiler?id=data-v-8d60f65a!../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./integrationsPremiumFeatureModal.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/app/components/modals/integrationsPremiumFeatureModal.vue
// module id = 348
// module chunks = 61